import { sleep } from "@/common/utils";

export default {
  namespaced: true,
  state: {
    iframeComponent: null,
    showIframe: false, // 是否展示iframe
    handshake: null, // postmateIframe对象
    iframe: null, // iframe对象
    connectIframeName: "", // 记录当前链接的iframe
    pageLoaded: false, // iframe内容加载完成
    iframeHeight: "100%",
    iframeWidth: "100%",
    iframeStartLoadingTime: null, // iframe内容开始加载时间
  },
  mutations: {
    upDateShowIframe(state, status) {
      state.iframeStartLoadingTime = Date.now(); // 记录开始加载的时间
      state.showIframe = status;
    },
    upDateStartTime(state) {
      state.iframeStartLoadingTime = Date.now();
    },
    upDateHandshake(state, status) {
      state.handshake = status;
    },
    upDateIframe(state, status) {
      state.iframe = Object.freeze(status);
    },
    upDateIframeName(state, status) {
      state.connectIframeName = status;
    },
    upDatePageLoaded(state, status) {
      state.pageLoaded = status;
    },
    upDateIframeComponent(state, status) {
      state.iframeComponent = status;
    },
    upDateSize(state, status) {
      if ("w" in status) {
        state.iframeWidth = status.w;
      } else {
        state.iframeWidth = "100%";
      }
      if ("h" in status) {
        state.iframeHeight = status.h;
      } else {
        state.iframeHeight = "100%";
      }
    },
  },
  actions: {
    upDateShowIframe({ commit }, status) {
      commit("upDateShowIframe", status);
    },
    upDateStartTime({ commit }) {
      commit("upDateStartTime");
    },
    upDateHandshake({ commit }, status) {
      commit("upDateHandshake", status);
    },
    upDateIframe({ commit }, status) {
      commit("upDateIframe", status);
    },
    upDateIframeName({ commit }, status) {
      commit("upDateIframeName", status);
    },
    upDatePageLoaded({ commit }, status) {
      commit("upDatePageLoaded", status);
    },
    upDateIframeComponent({ commit }, status) {
      commit("upDateIframeComponent", status);
    },
    // 重置
    async reSetIframe({ commit, state }) {
      commit("upDatePageLoaded", false);
      await sleep(500);
      commit("upDateShowIframe", false);
      commit("upDateIframeName", "");
      if (state.iframe) {
        state.iframe.destroy(); // 与iframe断开链接
        commit("upDateIframe", null);
      }
      if (state.handshake) {
        commit("upDateHandshake", null);
      }
    },
  },
};
